import React, { useEffect, useState } from 'react';
import Carousel from 'react-elastic-carousel';
import { ClockIcon, CalendarDaysIcon, CalendarIcon } from '@heroicons/react/24/outline';
import { useDispatch, useSelector } from 'react-redux';
import { getDeliveryTimeApi } from '../../../redux/Reducers/CreateOrderReducer';
import one_time from '../../../images/onetime.png';
import { getDifference, utcTimeToLocalTime, dateFn, getTimeZoneAbbr } from '../../../utils/dateTimeFormatter';
import calendar from '../../../../src/icons/icons-calendar@3x.png';
import clock from '../../../../src/icons/icons-clock@3x.png';
import bolt from '../../../../src/icons/power.svg';
import { isEmpty } from 'lodash';
import { setOrderDataAction } from '../../../redux/Actions/CreateOrderActions';
import Loader from '../../../components/Loader';
import { toast } from 'react-hot-toast';
import NoData from '../../../components/NoData';
import { amountCheckFn, formatAndSortStartTimes, subTypeText, timeIdGenarate } from '../../../utils/commonUtil';
import moment from 'moment';
import SelectableTiles from '../../../components/SelectableTiles';
export default function PickupDelivery() {
  const dispatch = useDispatch();
  const { selectedAddress } = useSelector((state) => state.serviceAddresses);
  const {
    orderType,
    orderProvider,
    availableSchedules,
    orderTimeSlots,
    orderRepeatFrequency,
    selectedServices,
    orderServiceAddress,
  } = useSelector((state) => state.createNewOrder);
  const [repeatfrequencyData, setRepeatfrequencyData] = useState([
    {
      id: 1,
      value: 'WEEK',
      displayValue: 'Week',
    },
    {
      id: 2,
      value: 'BIWEEKLY',
      displayValue: 'Other Week',
    },
    {
      id: 3,
      value: 'MONTH',
      displayValue: 'Month',
    },
  ]);
  const [selectedTimeSlots, setSelectedTimeSlots] = useState(orderTimeSlots || {});
  const [availableDeliverySchedules, setAvailableDeliverySchedules] = useState({});

  // const [pickupDatesForOneTime, setPickupDatesForOneTime] = useState([]);
  // const [pickupDatesForSubscription, setPickupDatesForSubscription] = useState([]);
  // const [pickupTimes, setPickupTimes] = useState([]);
  const [deliveryDatesForOneTime, setDeliveryDatesForOneTime] = useState([]);
  const [deliveryDatesForSubscription, setDeliveryDatesForSubscription] = useState([]);
  const [deliveryTimes, setDeliveryTimes] = useState([]);
  const [datesLoading, setDatesLoading] = useState(false);
  // const genaratePickupDates = (times) => {
  //   const pickupDatesOneTime = Object.keys(times).map((date, idx) => {
  //     return {
  //       id: dateFn('YYYYMMDD', date),
  //       value: dateFn('type3', date),
  //       dateYYYYMMDD: dateFn('YYYY-MM-DD', date),
  //     };
  //   });
  //   const pickupDatesSubscription = Object.keys(times).map((date, idx) => {
  //     return {
  //       id: dateFn('YYYYMMDD', date),
  //       value: dateFn('type3', date),
  //       dateYYYYMMDD: dateFn('YYYY-MM-DD', date),
  //     };
  //   });
  //   if (orderType === 'subscription') {
  //     setPickupDatesForSubscription(pickupDatesSubscription || []);
  //   } else if (orderType === 'oneTime') {
  //     setPickupDatesForOneTime(pickupDatesOneTime || []);
  //   }
  // };
  const genarateDeliveryDates = (times) => {
    const deliveryDatesOneTime = Object.keys(times)?.map((date, idx) => {
      return {
        id: dateFn('YYYYMMDD', date),
        value: dateFn('type3', date),
        dateYYYYMMDD: dateFn('YYYY-MM-DD', date),
        dateWeekday: dateFn('type7', date),
        dateMonthDate: dateFn('type8', date),
      };
    });
    const deliveryDatesSubscription = Object.keys(times)?.map((date, idx) => {
      const diffDays = getDifference(selectedTimeSlots?.first_pickup_date, date);
      return {
        id: dateFn('YYYYMMDD', date),
        daysAfter: diffDays,
        dateYYYYMMDD: dateFn('YYYY-MM-DD', date),
        dateWeekday: dateFn('type7', date),
        dateMonthDate: dateFn('type8', date),
        value: dateFn('type4', date),
      };
    });
    if (orderType === 'subscription') {
      setDeliveryDatesForSubscription(deliveryDatesSubscription || []);
    } else if (orderType === 'oneTime') {
      setDeliveryDatesForOneTime(deliveryDatesOneTime || []);
    }
  };

  // const onPickupDateChange = (date) => {
  //   if (date) {
  //     const day = dateFn('day', date)?.toLowerCase();
  //     const times = availableSchedules?.[date]?.map((item) => {
  //       return item?.weekday?.toLowerCase() === day && item;
  //     });
  //     const YYMMDDDate = moment(date).format('YYYY-MM-DD');
  //     const pickupTimes = times?.map((time, idx) => {
  //       return {
  //         value: `${utcTimeToLocalTime(`${YYMMDDDate}T${time?.start_time}`)} - ${utcTimeToLocalTime(
  //           `${YYMMDDDate}T${time?.end_time}`
  //         )}`,
  //         default: {
  //           start_time: time?.start_time,
  //           end_time: time?.end_time,
  //         },
  //         id: timeIdGenarate(YYMMDDDate, time?.start_time),
  //       };
  //     });
  //     setPickupTimes(pickupTimes || []);
  //   }
  // };
  const onDeliveryDateChange = (date) => {
    if (date) {
      const day = dateFn('day', date)?.toLowerCase();
      const times = availableDeliverySchedules?.[date]?.map((item) => {
        return item?.weekday?.toLowerCase() === day && item;
      });
      const YYMMDDDate = moment(date).format('YYYY-MM-DD');
      const deliveryTimes = times?.map((time, idx) => {
        return {
          value: `${utcTimeToLocalTime(
            `${YYMMDDDate}T${time?.start_time}`,
            orderServiceAddress?.time_zone
          )} - ${utcTimeToLocalTime(`${YYMMDDDate}T${time?.end_time}`, orderServiceAddress?.time_zone)}`,
          default: {
            start_time: time?.start_time,
            end_time: time?.end_time,
          },
          priority_fee: !isNaN(time?.priority_fee) && time?.priority_fee >= 0 && amountCheckFn(time?.priority_fee),
          is_rush: time?.is_rush && time?.is_rush,
          displayValue: genarateDisplayValueFn(YYMMDDDate, time),
          id: timeIdGenarate(YYMMDDDate, time?.start_time),
        };
      });
      setDeliveryTimes(deliveryTimes || []);
    }
  };
  const genarateDisplayValueFn = (YYMMDDDate, time) => {
    let start = `${YYMMDDDate}T${time?.start_time}`;
    let end = `${YYMMDDDate}T${time?.end_time}`;
    let zone = orderServiceAddress?.time_zone;
    if (!time?.is_rush) {
      return `${utcTimeToLocalTime(start, zone)} - ${utcTimeToLocalTime(end, zone)}`;
    } else if (!isNaN(time?.priority_fee)) {
      if (time?.priority_fee === 0) {
        return `${utcTimeToLocalTime(start, zone)} - ${utcTimeToLocalTime(end, zone)}`;
      } else if (time?.priority_fee > 0) {
        return `${utcTimeToLocalTime(start, zone)} - ${utcTimeToLocalTime(end, zone)}`;
      }
    } else {
      return `${utcTimeToLocalTime(start, zone)} - ${utcTimeToLocalTime(end, zone)}`;
    }
  };
  // const getPickupTimeFn = (provider, address) => {
  //   setDatesLoading(true);
  //   const response = getPickupTimeApi(provider, address);
  //   response.then((res) => {
  //     if (res?.status === 200 || res?.status === 201) {
  //       const data = formatAndSortStartTimes(res?.data || {});
  //       setDatesLoading(false);
  //       dispatch(setOrderDataAction({ availableSchedules: data || [] }));
  //       setSelectedTimeSlots((prevState) => ({
  //         ...prevState,
  //         pickup_date: Object.keys(data)?.[0],
  //         first_pickup_date: Object.keys(data)?.[0],
  //         pickup_start_time: data?.[Object.keys(data)?.[0]]?.[0]?.start_time,
  //         pickup_end_time: data?.[Object.keys(data)?.[0]]?.[0]?.end_time,
  //         selected_pickup_time_id: timeIdGenarate(
  //           Object.keys(data)?.[0],
  //           data?.[Object.keys(data)?.[0]]?.[0]?.start_time
  //         ),
  //       }));
  //     } else {
  //       setDatesLoading(false);
  //       toast.error(res?.message || 'Something went wrong');
  //     }
  //   });
  // };
  const getDeliveryTimeFn = async (date, type) => {
    setDatesLoading(true);
    const data = {
      items: selectedServices?.map((item) => {
        return {
          service_id: item?.service_id,
          quantity: item?.quantity,
        };
      }),
      pickup_date: orderType === 'oneTime' ? selectedTimeSlots?.pickup_date : selectedTimeSlots?.first_pickup_date,
      pickup_start_time: selectedTimeSlots?.pickup_start_time,
      type: type,
    };
    try {
      const response = await getDeliveryTimeApi(
        orderProvider ? orderProvider?.id : 'null',
        selectedAddress?.id,
        data,
        orderType == 'oneTime' ? 'ORDER' : 'subscription'
      );
      if (response?.status === 200 || response?.status === 201) {
        setDatesLoading(false);
        const data = formatAndSortStartTimes(response?.data?.data || {}, orderServiceAddress?.time_zone);
        setAvailableDeliverySchedules(data || {});
        const firstKey = Object.keys(data)[0];
        let firstNonRushSlot = Object.entries(data)
          .flatMap(([date, slots]) => slots.map((slot) => ({ date, ...slot })))
          .find((slot) => !slot.is_rush);
        if (!firstNonRushSlot) {
          firstNonRushSlot = Object.entries(data)
            .flatMap(([date, slots]) => slots.map((slot) => ({ date, ...slot })))
            .find((slot) => slot.is_rush);
        }
        setSelectedTimeSlots((prevState) => ({
          ...prevState,
          selected_dropoff_time_id: timeIdGenarate(firstNonRushSlot?.date, firstNonRushSlot?.start_time),
          dropoff_start_time: firstNonRushSlot?.start_time,
          dropoff_end_time: firstNonRushSlot?.end_time,
          dropoff_date: firstNonRushSlot?.date,
        }));
        onPriorityfeeChange(firstNonRushSlot);
        if (isEmpty(data)) {
          toast.error('No delivery times available for the selected pickup date and time');
          setDeliveryDatesForOneTime([]);
          setDeliveryTimes([]);
          setSelectedTimeSlots((prevState) => ({
            ...prevState,
            dropoff_date: null,
          }));
        }
      } else {
        setDatesLoading(false);
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      setDatesLoading(false);
      toast.error(error?.response?.data?.message || 'Something went wrong');
    }
  };
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }
  const onPriorityfeeChange = (time) => {
    dispatch(setOrderDataAction({ orderIsRush: time }));
  };

  // useEffect(() => {
  //   const providerid = orderProvider ? orderProvider?.id : null;
  //   if (orderTimeSlots?.pickup_date == null || orderTimeSlots?.pickup_date != selectedTimeSlots?.pickup_date) {
  //     getPickupTimeFn(providerid, selectedAddress?.id);
  //   }
  // }, [orderProvider]);

  // useEffect(() => {
  //   if (!isEmpty(availableSchedules)) {
  //     genaratePickupDates(availableSchedules);
  //   }
  // }, [availableSchedules]);

  useEffect(() => {
    if (selectedTimeSlots?.pickup_date || selectedTimeSlots?.first_pickup_date)
      getDeliveryTimeFn(
        orderType === 'oneTime' ? selectedTimeSlots?.pickup_date : selectedTimeSlots?.first_pickup_date,
        orderType === 'oneTime' ? 'ORDER' : 'SUBSCRIPTION'
      );
  }, [selectedTimeSlots?.selected_pickup_time_id]);

  useEffect(() => {
    if (!isEmpty(availableDeliverySchedules)) {
      genarateDeliveryDates(availableDeliverySchedules);
    }
  }, [availableDeliverySchedules]);

  // useEffect(() => {
  //   orderType === 'oneTime'
  //     ? onPickupDateChange(selectedTimeSlots?.pickup_date)
  //     : onPickupDateChange(selectedTimeSlots?.first_pickup_date);
  // }, [selectedTimeSlots?.pickup_date, selectedTimeSlots?.first_pickup_date]);

  useEffect(() => {
    availableDeliverySchedules &&
      selectedTimeSlots?.dropoff_date &&
      onDeliveryDateChange(orderType === 'oneTime' ? selectedTimeSlots?.dropoff_date : selectedTimeSlots?.dropoff_date);
  }, [availableDeliverySchedules, selectedTimeSlots?.dropoff_date]);

  useEffect(() => {
    if (!isEmpty(selectedTimeSlots)) {
      dispatch(setOrderDataAction({ orderTimeSlots: selectedTimeSlots || {} }));
    }
  }, [selectedTimeSlots]);

  return (
    <div className='z-0 col-span-full flex flex-col rounded-lg bg-white p-4 sm:col-span-8 sm:p-6'>
      {/* <header className='flex items-center pb-3'>
        <h5 className='go-heading-18'>Choose Your Delivery</h5>
      </header>
      <hr className='go-hr-dashed '></hr> */}
      {/* <div className='my-1 mt-5 flex items-center'>
        <img src={fastforward} alt='tick' className='mr-2 h-4 w-4' />
        Priority Delivery gives you a faster turnaround for an additional fee.
      </div> */}
      {/* <div className='my-1 flex items-center'>
        <img src={standard} alt='tick' className='mr-2 h-3 w-4' />
        Standard Delivery is always free.
      </div> */}
      {/* <p className=' text-client-text '>
        Best Matches at{' '}
        <span className='font-bold'>
          {orderServiceAddress?.full_address} ({moment.tz(orderServiceAddress?.time_zone).format('z')})
        </span>
      </p> */}
      {/* {orderType === 'oneTime' ? (
        <div className='mb-4'>
          <span className='go-label-16'>Pickup </span>
          <div className='mb-2 mt-2 flex items-center'>
            <span className='mr-4 rounded-sm bg-[#EEF4FE] p-1'>
              <CalendarIcon className='text-client-primarylight h-5 w-5' />
            </span>
            <span className='font-semibold text-black'>{dateFn('type4', selectedTimeSlots?.pickup_date)}</span>
          </div>
          <div className='flex items-center'>
            <span className='mr-4 rounded-sm bg-[#EEF4FE] p-1'>
              <img src={clock} alt='clock' className='h-5 w-5' />
            </span>
            <span className='font-semibold text-black'>
              {`${utcTimeToLocalTime(
                `${selectedTimeSlots?.pickup_date}T${selectedTimeSlots?.pickup_start_time}`,
                orderServiceAddress?.time_zone
              )} - ${utcTimeToLocalTime(
                `${selectedTimeSlots?.pickup_date}T${selectedTimeSlots?.pickup_end_time}`,
                orderServiceAddress?.time_zone
              )}`}
            </span>
          </div>
        </div>
      ) : (
        <div className='mb-4'>
          <span className='go-label-16'>Pickup </span>
          <div className='mb-2 mt-2 flex items-center'>
            <span className='mr-4 rounded-sm bg-[#EEF4FE] p-1'>
              <img src={calendar} alt='calendar' className='h-5 w-5 ' />
            </span>
            <span className='font-semibold text-black'>{dateFn('type4', selectedTimeSlots?.first_pickup_date)}</span>
          </div>
          <div className='flex items-center'>
            <span className='mr-4 rounded-sm bg-[#EEF4FE] p-1'>
              <img src={clock} alt='clock' className='h-5 w-5' />
            </span>
            <span className='font-semibold text-black'>
              {`${utcTimeToLocalTime(
                `${selectedTimeSlots?.first_pickup_date}T${selectedTimeSlots?.pickup_start_time}`,
                orderServiceAddress?.time_zone
              )} - ${utcTimeToLocalTime(
                `${selectedTimeSlots?.first_pickup_date}T${selectedTimeSlots?.pickup_end_time}`,
                orderServiceAddress?.time_zone
              )}`}
            </span>
          </div>
        </div>
      )} */}
      {/* <p className=' font-medium'>Standard Delivery is always free. </p> */}

      {/* {orderType === 'subscription' && (
        <div className='grid gap-0 sm:gap-4 xl:grid-cols-2'>
          <div className='py-2 sm:py-4'>
            <label className='go-label-16'>Repeat Every</label>
            <DropdownDateTime
              dropdownValues={repeatfrequencyData}
              onChange={(val) => {
                dispatch(setOrderDataAction({ orderRepeatFrequency: val }));
              }}
              placeholder='Pick Order Frequency'
              defaultValue={{ value: orderRepeatFrequency?.value || 'Select' }}
              type='text'
            />
          </div>
        </div>
      )} */}
      {datesLoading ? (
        <Loader text='fetching dates...' classes='h-52' />
      ) : (
        //   isEmpty(availableSchedules) ? (
        //   <NoData text='Choose a different provider.' classes='h-52' />
        // ) :
        <div>
          {/* <div className='h- grid gap-0 sm:gap-4 xl:grid-cols-2'>
            {orderType === 'oneTime' ? (
              !isEmpty(pickupDatesForOneTime) && (
                <div className='py-2 sm:py-4'>
                  <label className='go-label-16'>Choose Your Pickup Date</label>
                  <DropdownDateTime
                    dropdownValues={pickupDatesForOneTime || []}
                    icon={<CalendarDaysIcon />}
                    onChange={(date) => {
                      setSelectedTimeSlots((prevState) => ({
                        ...prevState,
                        pickup_date: date?.dateYYYYMMDD,
                        pickup_start_time: availableSchedules?.[date?.dateYYYYMMDD]?.[0]?.start_time,
                        pickup_end_time: availableSchedules?.[date?.dateYYYYMMDD]?.[0]?.end_time,
                        selected_pickup_time_id: timeIdGenarate(
                          date?.dateYYYYMMDD,
                          availableSchedules?.[date?.dateYYYYMMDD]?.[0]?.start_time
                        ),
                      }));
                    }}
                    placeholder='Pick a Date'
                    defaultValue={pickupDatesForOneTime?.find(
                      (item) => item?.id === dateFn('YYYYMMDD', selectedTimeSlots?.pickup_date)
                    )}
                    type='date'
                    disabled={isEmpty(pickupDatesForOneTime)}
                  />
                </div>
              )
            ) : (
              <div className='py-2 sm:py-4'>
                <label className='go-label-16'>Choose Your First Pickup Date</label>
                <DropdownDateTime
                  dropdownValues={pickupDatesForSubscription || []}
                  icon={<CalendarDaysIcon />}
                  onChange={(date) => {
                    setSelectedTimeSlots((prevState) => ({
                      ...prevState,
                      first_pickup_date: date?.dateYYYYMMDD,
                      pickup_start_time: availableSchedules?.[date?.dateYYYYMMDD]?.[0]?.start_time,
                      pickup_end_time: availableSchedules?.[date?.dateYYYYMMDD]?.[0]?.end_time,
                      selected_pickup_time_id: timeIdGenarate(
                        date?.dateYYYYMMDD,
                        availableSchedules?.[date?.dateYYYYMMDD]?.[0]?.start_time
                      ),
                    }));
                  }}
                  placeholder='Pick a Date'
                  defaultValue={pickupDatesForSubscription?.find(
                    (item) => item?.id === dateFn('YYYYMMDD', selectedTimeSlots?.first_pickup_date)
                  )}
                  type='date'
                  disabled={isEmpty(pickupDatesForSubscription)}
                />
              </div>
            )}
            {!isEmpty(pickupTimes) && (
              <div className='py-2 sm:py-4'>
                <label className='go-label-16'>Pickup Time</label>
                <DropdownDateTime
                  dropdownValues={pickupTimes || []}
                  icon={<ClockIcon />}
                  onChange={(time) => {
                    setSelectedTimeSlots((prevState) => ({
                      ...prevState,
                      pickup_start_time: time?.default?.start_time,
                      pickup_end_time: time?.default?.end_time,
                      selected_pickup_time_id: time?.id,
                    }));
                  }}
                  placeholder='Pick a Time'
                  defaultValue={pickupTimes?.find((item) => item?.id === selectedTimeSlots?.selected_pickup_time_id)}
                  type='time'
                />
              </div>
            )}
          </div>
          <hr className='go-hr-dashed mt-3 hidden sm:block'></hr> */}
          <div className='go-textblack-16 mb-1 text-center text-black'>
            Select Delivery Date & Time{' '}
            {`(${getTimeZoneAbbr(
              `${orderType === 'oneTime' ? selectedTimeSlots?.pickup_date : selectedTimeSlots?.first_pickup_date}T${
                selectedTimeSlots?.pickup_start_time
              }`,
              orderServiceAddress?.time_zone
            )})`}
          </div>
          <div className='mt-2 grid gap-0 sm:gap-4 xl:grid-cols-2 '>
            <div className='hidden pb-4 sm:block'>
              {orderType === 'oneTime' ? (
                !isEmpty(deliveryDatesForOneTime) && (
                  <SelectableTiles
                    dropdownValues={deliveryDatesForOneTime || []}
                    icon={<CalendarDaysIcon />}
                    showPriorityFee={false}
                    onChange={(date) => {
                      setSelectedTimeSlots((prevState) => ({
                        ...prevState,
                        dropoff_date: date?.dateYYYYMMDD,
                        dropoff_start_time: availableDeliverySchedules?.[date?.dateYYYYMMDD]?.[0]?.start_time,
                        dropoff_end_time: availableDeliverySchedules?.[date?.dateYYYYMMDD]?.[0]?.end_time,
                        selected_dropoff_time_id: timeIdGenarate(
                          date?.dateYYYYMMDD,
                          availableDeliverySchedules?.[date?.dateYYYYMMDD]?.[0]?.start_time
                        ),
                      }));
                      onPriorityfeeChange(availableDeliverySchedules?.[date?.dateYYYYMMDD]?.[0]);
                    }}
                    placeholder='Pick a Date'
                    defaultValue={deliveryDatesForOneTime?.find(
                      (item) => item?.id === dateFn('YYYYMMDD', selectedTimeSlots?.dropoff_date)
                    )}
                    type='date'
                  />
                )
              ) : (
                <div>
                  <SelectableTiles
                    dropdownValues={deliveryDatesForSubscription || []}
                    icon={<CalendarDaysIcon />}
                    showPriorityFee={false}
                    onChange={(date) => {
                      setSelectedTimeSlots((prevState) => ({
                        ...prevState,
                        dropoff_date: date?.dateYYYYMMDD,
                        dropoff_start_time: availableDeliverySchedules?.[date?.dateYYYYMMDD]?.[0]?.start_time,
                        dropoff_end_time: availableDeliverySchedules?.[date?.dateYYYYMMDD]?.[0]?.end_time,
                        selected_dropoff_time_id: timeIdGenarate(
                          date?.dateYYYYMMDD,
                          availableDeliverySchedules?.[date?.dateYYYYMMDD]?.[0]?.start_time
                        ),
                        daysAfter: date?.daysAfter,
                      }));
                      onPriorityfeeChange(availableDeliverySchedules?.[date?.dateYYYYMMDD]?.[0]);
                    }}
                    placeholder='Pick a Date'
                    defaultValue={deliveryDatesForSubscription?.find(
                      (item) => item?.id === dateFn('YYYYMMDD', selectedTimeSlots?.dropoff_date)
                    )}
                    type='date'
                  />
                </div>
              )}
            </div>
            <div className='pb-4 sm:hidden'>
              {orderType === 'oneTime' ? (
                !isEmpty(deliveryDatesForOneTime) && (
                  <Carousel itemsToScroll={1} itemsToShow={3} pagination={false}>
                    {deliveryDatesForOneTime?.map((item, idx) => (
                      <div
                        className={
                          'sm:border-3 rounded-lg border-2 bg-[#f5f5fb] p-1 py-2 px-2 text-center text-sm font-medium' +
                          ' ' +
                          classNames(
                            item?.id === dateFn('YYYYMMDD', selectedTimeSlots?.dropoff_date)
                              ? ' border-client-300'
                              : ' border-[#f5f5fb]'
                          )
                        }
                        key={idx + 'time'}
                        onClick={(e) => {
                          setSelectedTimeSlots((prevState) => ({
                            ...prevState,
                            dropoff_date: item?.dateYYYYMMDD,
                            dropoff_start_time: availableDeliverySchedules?.[item?.dateYYYYMMDD]?.[0]?.start_time,
                            dropoff_end_time: availableDeliverySchedules?.[item?.dateYYYYMMDD]?.[0]?.end_time,
                            selected_dropoff_time_id: timeIdGenarate(
                              item?.dateYYYYMMDD,
                              availableDeliverySchedules?.[item?.dateYYYYMMDD]?.[0]?.start_time
                            ),
                            daysAfter: item?.daysAfter,
                          }));
                          onPriorityfeeChange(availableDeliverySchedules?.[item?.dateYYYYMMDD]?.[0]);
                        }}
                      >
                        <span className=' block'>{item?.dateWeekday}</span>
                        <div className='min-w-12'>{item?.dateMonthDate}</div>
                      </div>
                    ))}
                  </Carousel>
                )
              ) : (
                <div>
                  <Carousel itemsToScroll={1} itemsToShow={3} pagination={false}>
                    {deliveryDatesForSubscription?.map((item, idx) => (
                      <div
                        className={
                          'sm:border-3 rounded-lg border-2 bg-[#f5f5fb] p-1 py-2 px-2 text-center text-sm font-medium' +
                          ' ' +
                          classNames(
                            item?.id === dateFn('YYYYMMDD', selectedTimeSlots?.dropoff_date)
                              ? ' border-client-300'
                              : ' border-[#f5f5fb]'
                          )
                        }
                        key={idx + 'time'}
                        onClick={(e) => {
                          setSelectedTimeSlots((prevState) => ({
                            ...prevState,
                            dropoff_date: date?.dateYYYYMMDD,
                            dropoff_start_time: availableDeliverySchedules?.[date?.dateYYYYMMDD]?.[0]?.start_time,
                            dropoff_end_time: availableDeliverySchedules?.[date?.dateYYYYMMDD]?.[0]?.end_time,
                            selected_dropoff_time_id: timeIdGenarate(
                              date?.dateYYYYMMDD,
                              availableDeliverySchedules?.[date?.dateYYYYMMDD]?.[0]?.start_time
                            ),
                            daysAfter: date?.daysAfter,
                          }));
                          onPriorityfeeChange(availableDeliverySchedules?.[date?.dateYYYYMMDD]?.[0]);
                        }}
                      >
                        <span className=' block'>{item?.dateWeekday}</span>
                        <div className='min-w-12'>{item?.dateMonthDate}</div>
                      </div>
                    ))}
                  </Carousel>
                </div>
              )}
            </div>
            {!isEmpty(deliveryTimes) && (
              <div className='pb-4'>
                <SelectableTiles
                  dropdownValues={deliveryTimes || []}
                  icon={<ClockIcon />}
                  onChange={(time) => {
                    setSelectedTimeSlots((prevState) => ({
                      ...prevState,
                      selected_dropoff_time_id: time?.id,
                      dropoff_start_time: time?.default?.start_time,
                      dropoff_end_time: time?.default?.end_time,
                    }));
                    onPriorityfeeChange(time);
                  }}
                  placeholder='Pick a Time'
                  defaultValue={deliveryTimes?.find((item) => item?.id === selectedTimeSlots?.selected_dropoff_time_id)}
                  type='time'
                />
                <div className='my-1 mt-3 flex items-center text-sm font-medium italic text-black'>
                  <img src={bolt} alt='tick' className='mr-1 h-[14px] w-[14px]' />
                  Fast delivery for an extra fee
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* {orderType === 'subscription' &&
        orderTimeSlots?.first_pickup_date &&
        orderTimeSlots?.pickup_start_time &&
        orderTimeSlots?.dropoff_end_time && (
          <div className='bg-client-gobg2 mt-5 flex rounded-md p-2'>
            <div className='w-16'>
              <img className='' src={one_time} width='40' height='40' />
            </div>
            <div className='flex'>
              <p className='go-textblackmedium-16 pl-4'>
                You've selected {subTypeText(orderRepeatFrequency?.value)} pickups on{' '}
                {orderRepeatFrequency?.value == 'MONTH'
                  ? `the ${dateFn('day1', orderTimeSlots?.first_pickup_date)} of each month at `
                  : `${dateFn('day', orderTimeSlots?.first_pickup_date)}s at `}
                {utcTimeToLocalTime(
                  `${orderTimeSlots?.first_pickup_date}T${orderTimeSlots?.pickup_start_time}`,
                  orderServiceAddress?.time_zone
                )}{' '}
                with delivery on{' '}
                {orderRepeatFrequency?.value == 'MONTH'
                  ? ` the ${dateFn('day1', orderTimeSlots?.dropoff_date)} of each month at `
                  : `${dateFn(
                      'day',
                      moment(orderTimeSlots?.first_pickup_date)
                        .add(orderTimeSlots?.daysAfter, 'days')
                        .format('YYYY-MM-DD')
                    )}s at `}
                {utcTimeToLocalTime(
                  `${orderTimeSlots?.dropoff_date}T${orderTimeSlots?.dropoff_start_time}`,
                  orderServiceAddress?.time_zone
                )}
              </p>
            </div>
          </div>
        )} */}
    </div>
  );
}
